import React, { useMemo } from 'react'
import { useSkills } from '@gopeerproject/chuck'
import moment from 'moment'
import { Grades } from '@helpers'
import { Text, IconText, Tooltip, User } from '@components/UI'

import { formatFileType } from '../../Classroom/components/Finder/helpers'

const Details = ({ file }) => {
  const { all: skills } = useSkills()

  const subjects = useMemo(
    () =>
      file.subjects
        ? file.subjects.map(
            (subject) => skills.find(({ value }) => value === subject)?.name
          )
        : [],
    [skills, file.subjects]
  )
  const grades = file.grades ? Grades.formatGrades(file.grades) : []

  return (
    <div className='gp-preview-header-details'>
      <Text className='text-c' style={{ opacity: 0.65 }}>
        {moment(file.createdAt).calendar()}
      </Text>
      <span className='gp-preview-header-dividerDot' />

      <div className='gp-preview-header-author'>
        <Text className='text-c'>
          <span style={{ opacity: 0.65 }}>By</span>{' '}
          <span className='semibold' style={{ opacity: 0.85 }}>
            {file.author.name}
          </span>
        </Text>
        {!!file.author.image && (
          <User
            size='smaller'
            style={{ marginLeft: 4 }}
            img={file.author.image}
            name={file.author.name}
            hideName
            type={file.author.type}
          />
        )}
      </div>
      <span className='gp-preview-header-dividerDot' />
      <IconText
        {...formatFileType(file.type)}
        className='gp-preview-header-fileType'
      />
      {!!subjects.length && (
        <>
          <span className='gp-preview-header-dividerDot' />
          <div className='gp-preview-header-subjects'>
            <Text className='text-c ' style={{ opacity: 0.65 }}>
              {subjects.join(', ')}
            </Text>
            <Tooltip
              content={
                <Text className='text-c semibold'>{subjects.join(', ')}</Text>
              }
              group='c6'
              className='theme color-f background-a border'
            />
          </div>
        </>
      )}

      {!!grades.length && (
        <>
          <span className='gp-preview-header-dividerDot' />
          <Text className='text-c' style={{ opacity: 0.65 }}>
            {grades.join(', ')}
          </Text>
        </>
      )}
    </div>
  )
}

export default Details
